import statusCodes from 'constants/statusCodes';
import { FEATURED, IN_STOCK, NOT_FEATURED, OUT_OF_STOCK } from 'constants/dataLayer';


export const getErrorString = (errorCode: (number|null)) => {
  switch (errorCode) {
    case statusCodes.NOT_FOUND:
      return 'NotFound';

    default:
      return 'Error';
  }
};

export const getFeaturedString = (featured: boolean) => {
  if (featured) {
    return FEATURED;
  }
  return NOT_FEATURED;
};

export const getStockString = (inStock: boolean) => {
  if (inStock) {
    return IN_STOCK;
  }
  return OUT_OF_STOCK;
};
